// extracted by mini-css-extract-plugin
module.exports = {"container":"e_S8","label":"e_T8","icon":"e_U8"};